import * as React from 'react'

import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material'
import { css } from '@emotion/react'
import { styled } from '@mui/material/styles'

interface ChipProps extends MuiChipProps {
    rounded?: boolean
    golden?: boolean
}

const StyledChip = styled(MuiChip, {
    shouldForwardProp: (propName: string) => !propName.startsWith('$'),
})<{ $golden: boolean; $rounded: boolean }>`
    border-radius: ${({ $rounded, theme }) => (!$rounded ? `${theme.shape.borderRadius}px` : undefined)};
    padding-left: ${({ icon }) => (!!icon ? '0.2rem' : undefined)};

    ${({ $golden, variant, theme }) => {
        if ($golden && variant === 'outlined') {
            return css`
                border-color: ${theme.palette.gold.main};
                background: ${theme.palette.gold.light};
            `
        }

        if ($golden && variant === 'filled') {
            return css`
                background: #d4b95c;
            `
        }
    }}
`

const Chip = ({ rounded = false, golden = false, ...props }: ChipProps) => {
    // The following `rounded` prop condition is ugly but otherwise it logs errors in console
    return <StyledChip $rounded={rounded} $golden={golden} {...props} />
}

export default Chip
